import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleRoadWorthyCheckRecordCategoryEnum } from '../enums/vehicle-road-worthy-check-record-category.enum';
import { VehicleRoadWorthyCheckStatusEnum } from '../enums/vehicle-road-worthy-check-status.enum';

/**
 * Vehicle road worthy checks filters
 */
export class VehicleRoadWorthyChecksFilters extends ApiRequestFilters {
	/**
	 * Check-out from date
	 */
	@TransformDate()
	startsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	startsAtTo?: Date;

	/**
	 * Check-out from date
	 */
	@TransformDate()
	endsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	endsAtTo?: Date;

	/**
	 * Individual dates that are contained within the StartsAt and EndsAt period
	 */
	@TransformDate()
	containsDates?: Date[];

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossFrom?: number;

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossTo?: number;

	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Vehicle Maintenances id values
	 */
	vehicleMaintenances?: number[];

	/**
	 * Status values
	 */
	statuses?: VehicleRoadWorthyCheckStatusEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: VehicleRoadWorthyCheckRecordCategoryEnum[];

	/**
	 * Vehicle category id values
	 */
	vehicleCategories?: number[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
